import clsx from 'clsx'
import { FC, ReactNode, useId } from 'react'

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate?: boolean
  value: string | number
  label?: ReactNode
  variant?: 'solid' | 'outline'
}

export const Checkbox: FC<CheckboxProps> = ({
  label,
  variant = 'solid',
  style,
  className,
  indeterminate,
  ...props
}) => {
  const id = useId()

  return (
    <div
      className={clsx(
        'form-check form-check-custom',
        {
          'form-check-solid': variant === 'solid',
        },
        className
      )}
      style={style}
    >
      <input
        {...props}
        id={id}
        className={clsx('form-check-input cursor-pointer', {
          'form-check-input-indeterminate': indeterminate,
        })}
        type="checkbox"
      />

      {label && (
        <label
          className="form-check-label"
          htmlFor={id}
          onClick={(e) => e.stopPropagation()}
        >
          {label}
        </label>
      )}
    </div>
  )
}
